import React from 'react';
import { Link } from 'react-router-dom';
import { MapPinIcon, EyeIcon, CalendarIcon, ClockIcon } from 'lucide-react';
import { Listing } from '../types';
interface FeaturedCardProps {
  listing: Listing;
  ctaText: string;
  ctaColor: 'red' | 'orange' | 'green' | 'blue';
  ctaLink: string;
}
const colorClasses = {
  red: 'bg-red-600 hover:bg-red-700',
  orange: 'bg-orange-500 hover:bg-orange-600',
  green: 'bg-green-600 hover:bg-green-700',
  blue: 'bg-blue-600 hover:bg-blue-700'
};
export function FeaturedCard({
  listing,
  ctaText,
  ctaColor,
  ctaLink
}: FeaturedCardProps) {
  return <div className="bg-white rounded-lg shadow-md overflow-hidden group" data-id="element-68">
      {/* Image Container */}
      <div className="relative h-48 overflow-hidden" data-id="element-69">
        <img src={listing.image} alt={listing.title} className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-300" data-id="element-70" />
        {/* User Avatar */}
        <div className="absolute top-3 left-3" data-id="element-71">
          <img src={listing.userAvatar} alt={listing.userName} className="w-10 h-10 rounded-full border-2 border-white shadow-md" data-id="element-72" />
        </div>
      </div>

      {/* Content */}
      <div className="p-4" data-id="element-73">
        <h3 className="font-semibold text-gray-900 mb-2 line-clamp-1" data-id="element-74">
          {listing.title}
        </h3>

        <div className="flex items-center justify-between text-sm text-gray-500 mb-3" data-id="element-75">
          <div className="flex items-center space-x-1" data-id="element-76">
            <MapPinIcon className="w-4 h-4 text-green-600" data-id="element-77" />
            <span data-id="element-78">{listing.location}</span>
          </div>
          <div className="flex items-center space-x-1" data-id="element-79">
            <EyeIcon className="w-4 h-4" data-id="element-80" />
            <span data-id="element-81">{listing.views} Views</span>
          </div>
        </div>

        {listing.eventDate && <div className="flex items-center space-x-4 text-sm text-gray-500 mb-3" data-id="element-82">
            <div className="flex items-center space-x-1" data-id="element-83">
              <CalendarIcon className="w-4 h-4 text-red-500" data-id="element-84" />
              <span data-id="element-85">{listing.eventDate}</span>
            </div>
            {listing.eventTime && <div className="flex items-center space-x-1" data-id="element-86">
                <ClockIcon className="w-4 h-4" data-id="element-87" />
                <span data-id="element-88">{listing.eventTime}</span>
              </div>}
          </div>}

        <Link to={ctaLink} className={`block w-full text-center py-2 rounded-md text-white text-sm font-medium transition-colors ${colorClasses[ctaColor]}`} data-id="element-89">
          {ctaText}
        </Link>
      </div>
    </div>;
}